<template>
  <div class="guest-details-form form-container">
    <h1>Checkout</h1>
    <h3>Guest Details</h3>

    <div class="field-set">
      <RequiredTextField
        label="Email*"
        name="email"
        v-model="email"
        :errors="errors"
        @validate="validate"
      />

      <RequiredTextField
          label="Phone Number*"
          name="mobile_phone"
          v-model="mobile_phone"
          :errors="errors"
          @validate="validate"
      />
    </div>

    <div class="field-set">
      <RequiredTextField
          label="First Name*"
          name="first_name"
          v-model="first_name"
          :errors="errors"
          @validate="validate"
      />
      
      <RequiredTextField
        label="Last Name*"
        name="last_name"
        v-model="last_name"
        :errors="errors"
        @validate="validate"
      />
    </div>

    <RequiredTextField
      label="Address Line 1*"
      name="address1"
      v-model="address1"
      :errors="errors"
      @validate="validate"
    />

    <div class="field-set">
      <div class="field-group">
        <label>Address Line 2</label>
        <input type="text" name="address2" v-model="address2" />
      </div>

      <div
        :class="{ 'field-group': true, error: errors.country_name }"
        class="field-group"
      >
        <label>Country*</label>
        <div class="select">
          <select
            name="country_name"
            required="true"
            v-model="country_name"
            @change="updateCountry"
            aria-label="Country"
          >
            <option
              v-for="country in countries"
              :value="country.iso"
              :key="country.name"
            >
              {{ country.name }}
            </option>
          </select>
          <span class="error-msg" v-if="errors.country_name">
            {{ errors.country_name }}
          </span>
        </div>
      </div>
    </div>

    <div class="field-set field-triple">
      <RequiredTextField
        label="Zip Code / Postal Code*"
        name="zip"
        v-model="zip"
        :errors="errors"
        @validate="validate"
        v-if="requires_zip"
      />

      <RequiredTextField
        label="City*"
        name="city"
        v-model="city"
        :errors="errors"
        @validate="validate"
      />

      <div
        :class="{ 'field-group': true, error: errors.state_name }"
        v-if="state_names && state_names.length"
      >
        <label>State*</label>
        <div class="select">
          <select
            name="state_name"
            required="true"
            v-model="state_name"
            aria-label="State"
            :key="`state-${$store.state.state_name}`"
          >
            <option
              v-for="({ name, description }, n) in state_names"
              :value="name"
              :key="`${name}-${n}`"
            >
              {{ description }}
            </option>
          </select>
          <span class="error-msg" v-if="errors.state_name">
            {{ errors.state_name }}
          </span>
        </div>
      </div>
    </div>

    <div class="field-group">
      <label>Special Requirements</label>
      <textarea name="client_comments" v-model="client_comments" />
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import countries from 'fixtures/countries.json'
import axios from 'axios'
import RequiredTextField from './RequiredTextField.vue'

export default {
  props: ['errors'],
  data() {
    return {
      state_names: null,
      requires_zip: true,
      countries: this.sortedCountries(),
    }
  },
  computed: {
    ...mapFields([
      'form.first_name',
      'form.last_name',
      'form.email',
      'form.mobile_phone',
      'form.address1',
      'form.address2',
      'form.country_name',
      'form.zip',
      'form.city',
      'form.state_name',
      'form.client_comments',
    ]),
  },
  methods: {
    sortedCountries() {
      // move US to top of list
      let from = countries.findIndex((c) => c.iso == 'US')
      let to = 0
      countries.splice(to, 0, countries.splice(from, 1)[0])
      return countries
    },
    updateCountry() {
      let country = this.$store.state.form.country_name
      if (!country) return
      axios
        .get(`/checkout/${country}/states`)
        .then((response) => (this.state_names = response.data))
      axios
        .get(`/checkout/${country}/zip`)
        .then((response) => (this.requires_zip = response.data.requires_zip))
    },
    validate() {
      if (!this.$parent.$data.valid) {
        this.$emit('validate')
      }
    },
  },
  mounted() {
    this.updateCountry()
  },
  components: {
    RequiredTextField,
  },
}
</script>

<style>
.guest-details-form {
  h1 {
    display: none;
  }

  @mixin breakpoint $tablet {
    h1 {
      display: block;
    }

    h3 {
      margin: 30px 0 10px;
    }
  }
}

@mixin breakpoint $tablet {
  .field-set {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    .field-group {
      width: calc(50% - 10px);
    }

    &.field-triple {
      .field-group {
        width: calc(33.33% - 10px);
      }
    }
  }
}
</style>
